import React from "react";
import PolicyLayout from "./PolicyLayout";

function DeliveryIssues() {
  return (
    <PolicyLayout
      title="Lost, delayed and damaged package policy"
      intro="Use this evidence process when a paid physical order does not arrive as expected or reaches you with a parcel problem."
    >
      <section>
        <h2>When a parcel has not arrived</h2>
        <p>Check the submitted address, building reception, household members and any delivery status supplied for the order. Then email the order number, recipient name, full delivery address and the last status seen. Do not send payment credentials.</p>
        <p>We will compare the request with available payment and dispatch records and seek a trace from the delivery channel where a parcel reference is available. A delayed scan is investigated before the parcel is treated as lost. When loss is established, the available remedy is confirmed according to stock, payment evidence and mandatory consumer rights.</p>
      </section>

      <section>
        <h2>Visible damage, leakage or tampering</h2>
        <p>Stop opening the package if broken glass, liquid, exposed electrical parts or a sharp fragment makes handling unsafe. Photograph the outer parcel from more than one side, the shipping label, internal protection and each affected product. Report the problem after discovery and before disposing of the item or packaging, unless safe disposal is necessary to prevent injury.</p>
        <p>Do not taste food or drink from broken, leaking, swollen, unsealed or tampered packaging. Do not connect a lamp with a damaged cord, plug, diffuser or housing. Keep children and pets away from fragments and small loose components.</p>
      </section>

      <section>
        <h2>Missing contents or an incorrect item</h2>
        <p>List what the parcel contained and what the order should have contained. Include a single photograph showing all received items together with the packing materials. Retain any incorrect item unused while the claim is assessed; opened consumables should be handled only when necessary to identify an unsafe condition.</p>
      </section>

      <section>
        <h2>Assessment and outcome</h2>
        <p>The review matches the photographs, parcel label, order lines, payment status and available dispatch information. We may request another image, safe disposal confirmation, or an authorised return. Depending on the established problem and lawful remedy, the outcome can be replacement from available stock, refund through the original payment route, a proportionate price adjustment, or completion of missing supply.</p>
        <p>Damage caused after delivery by misuse, unsuitable electricity, impact, moisture, incorrect heat treatment or care contrary to the product instructions is distinguished from transit damage. This distinction does not limit rights for a latent defect or unsafe product.</p>
      </section>
    </PolicyLayout>
  );
}

export default DeliveryIssues;
